import type { BusinessConnectionMst, Common } from '@libs/domain';
import { type BusinessConnectionType, businessConnectionType } from '@libs/enums';
import { MstRegistration, MstRegistrationRaw } from '@libs/templates/mst';

class BusinessConnectionMstRegistration
  extends MstRegistration
  implements
    Pick<BusinessConnectionMst['schema'], 'businessConnectionClass'>,
    Pick<Common['schema'], 'eligibleBillingProvider'>
{
  private constructor(
    mstRegistration: MstRegistration,
    readonly businessConnectionClass: Set<BusinessConnectionType>,
    readonly eligibleBillingProvider: boolean,
  ) {
    super(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      mstRegistration.validityStartDate,
      mstRegistration.validityEndDate,
      mstRegistration.mstNote,
    );
  }

  static init(code?: string) {
    return new BusinessConnectionMstRegistration(MstRegistration.baseInit(code), new Set([]), false);
  }

  static fromRaw(raw: BusinessConnectionMstRegistrationRaw) {
    return new BusinessConnectionMstRegistration(
      MstRegistration.baseFromRaw(raw),
      new Set(raw.businessConnectionClass.map(businessConnectionType.toEnum)),
      raw.eligibleBillingProvider,
    );
  }
}

class BusinessConnectionMstRegistrationRaw
  extends MstRegistrationRaw
  implements
    Pick<BusinessConnectionMst['record'], 'businessConnectionClass'>,
    Pick<Common['record'], 'eligibleBillingProvider'>
{
  private constructor(
    mstRegistrationRaw: MstRegistrationRaw,
    readonly businessConnectionClass: string[],
    readonly eligibleBillingProvider: boolean,
  ) {
    super(
      mstRegistrationRaw.id,
      mstRegistrationRaw.version,
      mstRegistrationRaw.code,
      mstRegistrationRaw.name,
      mstRegistrationRaw.mstSpareName01,
      mstRegistrationRaw.mstSpareName02,
      mstRegistrationRaw.validityStartDate,
      mstRegistrationRaw.validityEndDate,
      mstRegistrationRaw.mstNote,
    );
  }

  static fromModel(businessConnectionMstRegistration: BusinessConnectionMstRegistration) {
    return new BusinessConnectionMstRegistrationRaw(
      MstRegistrationRaw.baseFromModel(businessConnectionMstRegistration),
      [...businessConnectionMstRegistration.businessConnectionClass],
      businessConnectionMstRegistration.eligibleBillingProvider,
    );
  }
}

export { BusinessConnectionMstRegistration, BusinessConnectionMstRegistrationRaw };
